import * as React from "react";
import { Hr } from "@grandvisionhq/elements";
import { useFeatureToggles, useIntl } from "@grandvisionhq/state";
import { getNotification } from "../../../../../../../../utils/modules/EcommContent/components/VariantSelectorTree/utils/get-notification.js";
import { getSelectedNode } from "../../../../../../../../utils/modules/EcommContent/components/VariantSelectorTree/utils/get-selected-node.js";
import { SingleVariantNode } from "../../../../../../../SingleVariantNode/modules/EcommContent/components/VariantSelectorTree/components/SingleVariantNode/SingleVariantNode.js";
import { useEcommFacetContext } from "../../../../../../../../../../context/modules/EcommContent/context/EcommFacetContext.js";
import { FacetPicker } from "../../../../../../../../../FacetPickers/components/modules/EcommContent/components/FacetPickers/components/FacetPicker.js";
import { FacetWithTextNode } from "../../../../../../../../../FacetPickers/components/modules/EcommContent/components/FacetPickers/components/FacetWithTextNode.js";
import { FacetPickerWithDrawer } from "../../../../../../../../../FacetPickers/components/modules/EcommContent/components/FacetPickers/components/FacetPickerWithDrawer.js";
import { FacetWithImage } from "../../../../../../../../../FacetPickers/components/modules/EcommContent/components/FacetPickers/components/FacetWithImage.js";
import { FacetPickerDropdown } from "../../../../../../../../../FacetPickers/FacetPickerDropdown/modules/EcommContent/components/FacetPickers/FacetPickerDropdown/FacetPickerDropdown.js";
import { useProductData } from "../../../../../../../../../../../../context/context/product-context-hooks.js";
const VariantTreeLevel = ({
  className,
  treeLevelVariants,
  currentNode
}) => {
  const { isPdpVariantDrawerEnabled } = useFeatureToggles();
  const { getFormattedLabel } = useIntl();
  const {
    product: { productType },
    facetConfigList
  } = useProductData();
  const {
    handleVariantSelection,
    clickedFacetKeys,
    setClickedFacetKeys,
    setNotificationType,
    notificationType
  } = useEcommFacetContext();
  const facetConfig = facetConfigList?.find(
    (config) => config.facetKey === treeLevelVariants[0]?.facetKey
  );
  if (facetConfig === void 0 || !treeLevelVariants.length) return null;
  const title = getFormattedLabel(facetConfig.titleLabelKey, {
    labelData: { number: treeLevelVariants.length }
  });
  const handleFacetSelection = (props) => {
    const { name, sku, facetTerm } = props;
    facetConfig?.onFacetSelection?.({
      type: productType,
      name,
      id: sku,
      [facetConfig.facetKey]: facetTerm
    });
    setClickedFacetKeys(Array.from(/* @__PURE__ */ new Set([...clickedFacetKeys, facetConfig.facetKey])));
    setNotificationType("info");
    handleVariantSelection(props);
  };
  const singleVariantFacet = treeLevelVariants.length === 1 ? treeLevelVariants[0] : void 0;
  const activeFacet = getSelectedNode(clickedFacetKeys, treeLevelVariants, facetConfig, currentNode);
  const { Right, Bottom } = facetConfig.slots || {};
  const rightSlot = Right ? /* @__PURE__ */ React.createElement(Right, { treeLevelVariants, facetKey: currentNode?.facetKey }) : void 0;
  const Notification = getNotification(
    clickedFacetKeys,
    treeLevelVariants,
    facetConfig,
    activeFacet,
    notificationType
  );
  if (singleVariantFacet && facetConfig.showSingleFacetAs !== "display-type") {
    return /* @__PURE__ */ React.createElement(
      SingleVariantNode,
      {
        facetConfig,
        facetTerm: singleVariantFacet.facetTerm,
        rightSlot
      }
    );
  }
  switch (facetConfig.displayType) {
    case "dropdown":
      return /* @__PURE__ */ React.createElement(React.Fragment, null, activeFacet && /* @__PURE__ */ React.createElement(
        FacetPickerDropdown,
        {
          title,
          rightSlot,
          onPick: handleFacetSelection,
          activeFacet,
          items: treeLevelVariants,
          productType
        }
      ), Notification && /* @__PURE__ */ React.createElement(Notification, { notificationType }), Bottom ? /* @__PURE__ */ React.createElement(Bottom, null) : null, /* @__PURE__ */ React.createElement(Hr, null));
    case "thumbnail":
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
        FacetPickerWithDrawer,
        {
          itemComponent: FacetWithImage,
          items: treeLevelVariants,
          onPick: handleFacetSelection,
          title,
          productType,
          activeFacet,
          shouldShowFacetName: true,
          className,
          rightSlot,
          isDrawerEnabled: isPdpVariantDrawerEnabled
        }
      ), Notification && /* @__PURE__ */ React.createElement(Notification, { notificationType }), Bottom ? /* @__PURE__ */ React.createElement(Bottom, null) : null, /* @__PURE__ */ React.createElement(Hr, null));
    case "text-node":
    default:
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
        FacetPicker,
        {
          itemComponent: FacetWithTextNode,
          facetTermFormatter: facetConfig.facetTermFormatter,
          items: treeLevelVariants,
          onPick: handleFacetSelection,
          title,
          productType,
          activeFacet,
          shouldShowFacetName: false,
          className,
          rightSlot
        }
      ), Notification && /* @__PURE__ */ React.createElement(Notification, { notificationType }), Bottom ? /* @__PURE__ */ React.createElement(Bottom, null) : null, /* @__PURE__ */ React.createElement(Hr, null));
  }
};
export {
  VariantTreeLevel
};
//# sourceMappingURL=VariantTreeLevel.js.map
